module.exports = __webpack_public_path__ + "img/pvc_650g_b1_farbauswahl_komplett.76752356.jpg";